<script setup lang="ts">
/**
 * 発注ステータスバッジ
 */
import { i18n } from '@/i18n';

/**
 * propsの定義
 * @param orderStatusStr - 注文ステータス
 */
type Props = {
  orderStatusStr?: string;
};

withDefaults(defineProps<Props>(), { orderStatusStr: '', displayValue: '' });
const t = i18n.t;
</script>

<template>
  <div class="status-tag">
    <div :class="`container status-tag__container status-tag__container--${orderStatusStr}`">
      <span :class="`container--${orderStatusStr}`">
        {{ t(orderStatusStr) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.status-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &__container {
    &--NoRecommendation {
      background-color: $semanticWhite; // ありえない
    }

    &--Recommended {
      background-color: $optionalOrange;
    }

    &--ApprovalRequested {
      background-color: $optionalPink;
    }
    &--ApprovedAwaitingDeliveryDate {
      background-color: $optionalViolet;
    }

    &--DeliveryDateConfirmed {
      border-color: $semanticSuccess;
      border-width: 1px;
    }

    &--QuantityConfirmed {
      border-color: $semanticSuccess;
      border-width: 1px;
    }

    &--PartialDelivery {
      background-color: $optionalCyan;
    }

    &--Confirmed {
      background-color: $semanticSuccess;
    }

    &--Delivered {
      background-color: $optionalLightBlue;
    }

    &--DeliveryDelayed {
      background-color: $semanticError;
    }

    &--DisplayEnded {
      background-color: $semanticWhite;
      border: 1px solid $borderDefault;
    }

    // Unknownの時は、アラートを表示
    &--Unknown {
      background-color: $semanticError;
    }
  }
}

.container {
  justify-content: center;
  align-items: center;
  min-width: 80px;
  max-width: 80px;
  border-radius: 90px;
  padding-top: 4px;
  padding-bottom: 4px;
  color: $semanticWhite;
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  line-height: 12px;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--DeliveryDateConfirmed {
    color: $semanticSuccess;
  }

  &--QuantityConfirmed {
    color: $semanticSuccess;
  }

  &--DisplayEnded {
    color: $textSecondary;
  }
}
</style>
